export enum CyberEventUserType {
    Contractor = 'Contractor',
    Guest = 'Guest',
    Both = 'Both'
}